<script>
    import { ServerVersion, PageVersion } from '../../script/_init'
</script>

<footer>
    <div class="inner">
        <img src="/img/logo.png" alt="">
        <div class="title">던전 스쿼드 팀빌딩</div>
        <div class='copyright'>copyright. 게으른거북, 탁나현</div>
        <div class='version'>서버 버전 : {$ServerVersion} / 페이지 버전 : {$PageVersion}</div>
    </div>
</footer>

<style lang="scss">
    footer {
        /* 정중앙 표시(높이 지정 필수) */
        background: $cl5;
        width: 100%;
        height: 130px;
        margin-top: 20px;
        text-align: center;

        display: flex;
        justify-content: center;
        align-items: center;

        img {
            width: 35px;
        }

        .title {
            margin: 5px;
            color: $cl3;
            font-size: 16px;
            font-family: aggro;
        }
        .copyright {
            margin: 5px;
            color: $cl3;
            font-size: 12px;
            font-family: blade;
        }
        .version {
            margin: 5px;
            font-size: 10px;
        }
    }
</style>